export default function getSiteUrl(path?: string): string {
  if (path) {
    const p = path.replace(/^\/|\/$/g, "")
    return `${
      process.env.NEXT_PUBLIC_WEBSITE_BASE_URL || "http://localhost:3000"
    }/${p}`
  }
  return process.env.NEXT_PUBLIC_WEBSITE_BASE_URL || "http://localhost:3000"
}
